import Resources from '../../helpers/resources';
import { activateError } from '../error-handling/error-handling-actions';
import { LANDING_SPINNER, COMPLETE_ASSIGNMENT_SPINNER } from '../../helpers/constants';
import {
  completeAssignmentQtc,
  startLoadingActivity,
  stopLoadingActivity
} from '../conquest/conquest.actions';
import { getValueFromUrl } from '../../helpers/utils';
import { activateModal } from '../modal/modal-actions';
import { enableSpinner, disableSpinner } from '../spinner/spinner-actions';

export const ASSIGNMENT_DETAILS_FETCHED = 'ASSIGNMENT_DETAILS_FETCHED';
export const DUMMY_OFF = 'DUMMY_OFF';

export const assignmentDetailsFetched = payload => ({
  type: ASSIGNMENT_DETAILS_FETCHED,
  payload
});

export const offDummy = () => ({
  type: DUMMY_OFF
});

export const fetchAssignmentDetails = assignmentId => async (dispatch) => {
  dispatch(enableSpinner(LANDING_SPINNER));
  try {
    const assignmentDetailsResponse = await Resources.fetchAssignmentDetails
      .get({ assignmentId })
      .send();

    const { status, data } = assignmentDetailsResponse;

    if (status === 200 || status === 204) {
      dispatch(assignmentDetailsFetched(data));
      dispatch(offDummy());
      dispatch(disableSpinner(LANDING_SPINNER));
    }
  } catch (e) {
    dispatch(activateError('network error'));
    dispatch(offDummy());
    dispatch(disableSpinner(LANDING_SPINNER));
  }
};

export const handInQtc = () => (dispatch) => {
  dispatch(activateModal(false));
  dispatch(completeAssignmentQtc({
    assignmentId: getValueFromUrl('assignmentId'),
    startFetch: () => {
      dispatch(startLoadingActivity());
      dispatch(enableSpinner(COMPLETE_ASSIGNMENT_SPINNER));
    },
    endFetch: () => {
      dispatch(stopLoadingActivity());
      dispatch(disableSpinner(COMPLETE_ASSIGNMENT_SPINNER));
    }
  }));
};
